import { MoonIcon } from '@phosphor-icons/react'
import { observer } from 'mobx-react-lite'
import { DropdownMenuItem } from 'app/components/ui/dropdown-menu'
import { Switch } from 'app/components/ui/switch'
import { useThemeToggle } from 'app/hooks/useThemeToggle'

/** Dark mode row of the sidebar user menu. It keeps the menu open so the change is visible. */
export const ThemeMenuItem = observer(function ThemeMenuItem({ className }: { className?: string }) {
  const { available, ready, isDark, toggle } = useThemeToggle()

  if (!available) return null

  return (
    <DropdownMenuItem
      role="menuitemcheckbox"
      aria-checked={isDark}
      disabled={!ready}
      className={className}
      onSelect={(event) => {
        event.preventDefault()
        toggle()
      }}
    >
      <MoonIcon aria-hidden="true" />
      <span className="grow">Dark mode</span>
      <Switch checked={isDark} tabIndex={-1} aria-hidden="true" className="pointer-events-none" />
    </DropdownMenuItem>
  )
})
